import React from 'react';

const CHAT_URL =
  'https://argong-cs-web-a9fzehcbhhehaud6.koreacentral-01.azurewebsites.net/customer-chat';

function ChatButton() {
  return (
    <a
      href={CHAT_URL}
      target='_blank'
      rel='noopener noreferrer'
      className='chat-float-btn'
      aria-label='고객 채팅 상담 열기'>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='28'
        height='28'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'>
        <path d='M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z' />
      </svg>
    </a>
  );
}

export default ChatButton;

